// Material
import { styled } from '@mui/material/styles'
import {
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
} from '@mui/material'

const StyledListItemButton = styled(ListItemButton)`
  height: 50px;
  text-align: inherit;
  box-sizing: border-box;
  padding: 8px 15px;
`

const StyledListItem = styled(ListItem)`
  text-align: inherit;
  padding: 0;
  .MuiTouchRipple-child {
    background-color: #f9f9f9;
  }
`

const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 24px;
  margin-left: 15px;
  color: ${({ theme }) => theme.palette.primary500};
`

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '.MuiTypography-root': {
    ...theme.typography.subtitle3,
  },
}))

const StyledSecondaryListItemText = styled(ListItemText)(({ theme }) => ({
  flex: 'none',
  '.MuiTypography-root': {
    ...theme.typography.subtitle3,
    color: theme.palette.secondary.main,
  },
}))

const StyledDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

interface Props {
  Icon: JSX.Element
  onClick: () => any
  children: JSX.Element | string
  secondaryText?: number | string
  secondaryTextLoading?: boolean
  disabled?: boolean
}

export function ProfileActionItem({
  Icon,
  onClick,
  children,
  secondaryText,
  secondaryTextLoading,
  disabled,
}: Props) {
  return (
    <>
      <StyledListItem onClick={onClick} disabled={disabled}>
        <StyledListItemButton disableGutters>
          <StyledListItemIcon>{Icon}</StyledListItemIcon>
          <StyledListItemText>{children}</StyledListItemText>

          {secondaryTextLoading ? (
            <Skeleton sx={{ minWidth: '25px' }} />
          ) : secondaryText ? (
            <StyledSecondaryListItemText>
              {secondaryText}
            </StyledSecondaryListItemText>
          ) : null}
        </StyledListItemButton>
      </StyledListItem>

      <StyledDivider />
    </>
  )
}

ProfileActionItem.defaultProps = {
  secondaryText: null,
  secondaryTextLoading: false,
  disabled: false,
}
